module.exports = __webpack_public_path__ + "static/media/tree_19.471841de.jpg";